export const yellow = {
  yellow100: '#FFFACC',
  yellow200: '#FFF499',
  yellow300: '#FFEC66',
  yellow400: '#FFE43F',
  yellow500: '#FFD800',
  yellow600: '#DBB600',
  yellow700: '#B79500',
  yellow800: '#937600',
};
